import Toast from "../modal/toast";
import { apiFetch } from "../../services/api-fetch";
import { triggerEvent } from "../../services/helpers/trigger-event";
import { DndHandler } from "./utils/dnd-handler";
import * as loader from "./utils/utils";
import Preview from "./utils/preview";
import Dispatcher from "events-dispatch";

const events = {
  "loaded": "file.loader.events.loaded",
  "startLoad": "file.loader.events.start.load",
  "error": "file.loaded.events.error"
}

class FileLoader {
  static get events() {
    return events;
  }

  constructor(element, config) {
    new Dispatcher(this);

    const tokenInput = element.querySelector("[name=token]");

    this.nodes = this._DOMInit(element);
    this.action = this.nodes.element.dataset.action;

    this.uploadFieldName = config.uploadField || "image";
    this.loadedFieldName = config.loadedField || "image";
    this.token = tokenInput ? tokenInput.value : null;

    this.maxCount = parseInt(this.nodes.element.dataset.maxCount) || 1;
    this.maxSize = parseInt(this.nodes.element.dataset.maxSize) || 0;
    this.maxSizeTotal = parseInt(this.nodes.element.dataset.maxSizeTotal) || 0;
    this.accept = this.nodes.element.dataset.accept || false;

    this.multiple = this.maxCount > 1;

    this.withoutPreviews = config.withoutPreviews || !this.nodes.previewsContainer;

    let defaults = Array.from(this.nodes.element.querySelectorAll(`[name="${this.loadedFieldName}"]`));
    this._initDefaults(defaults);
  }

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = !!value;
    this.nodes.element.classList.toggle("loading", this._loading);
  }

  _DOMInit(el) {
    // кнопка Выбрать файл
    let addFilesButton = el.querySelector('[data-select-files]');
    if (addFilesButton) {
      addFilesButton.addEventListener("click", () => {
        this._selectFiles()
          .then(({ files, input }) => {
            input.remove();
            this._loadFiles(files);
          })
      });
    }

    // зона drag'n'drop
    let dnd = new DndHandler('.dnd', el);
    dnd.on("load", (data) => {
      this._loadFiles(data.files);
    })

    // родительская форма
    let form = el.closest('form');

    return {
      form: form,
      element: el,
      error: el.querySelector('[data-error]'),
      previewsContainer: el.querySelector('[data-previews]'),
    }
  }

  _getPreview(file) {
    return this.withoutPreviews ? null : new Preview(file);
  }

  _initDefaults(inputs) {

    inputs.forEach(input => {
      let url = input.value;
      if (url) {
        let preview = this._getPreview();
        if (preview) {
          preview.show(url, this.loadedFieldName);
          this.nodes.previewsContainer.appendChild(preview.element);
          input.remove();
        }
      } else {
        input.remove();
      }
      
    })
  }

  _selectFiles() {
    return loader.selectFiles({
      multiple: this.multiple,
      accept: this.accept,
    });
  }

  _loadFiles(files) {
    this._clear("silent");

    

    for (let i = 0, count = files.length; i < count; i++) {
      if (i >= this.maxCount) break;
      this._loadFile(files[i]);
    }
  }

  _loadFile(file) {
    this.loading = true;

    this.trigger(events.startLoad, file);

    let preview = this._getPreview(file);
    if (preview) {
      this.nodes.previewsContainer.appendChild(preview.element);
    }
    
    let data = new FormData();
    data.append(this.uploadFieldName, file);

    if (this.token) {
      data.append("token", this.token);
    }

    apiFetch(this.action, {
      body: data,
      method: "POST"
    }).then(res => {
      if (res.success) {
        let url = res.file.url;

        if (preview) {
          preview.show(url, this.loadedFieldName);
        }
        
        this.loading = false;

        this.trigger(events.loaded, res.file);
      } else {
        throw new Error(res.error);
      }
      
    }).catch(err => {
      if (preview) {
        preview.error = true;
      }
      
      this._showError(err);

      this.trigger(events.error, err);
    });
  }

  _showError(error) {
    Toast.open(error, {
      state: "error"
    });
    console.error(error);
  }

  _clear(silent) {
    this.nodes.previewsContainer.innerHTML = "";

    if (!silent) {
      triggerEvent(this.nodes.form, "change");
    }
  }
}

export default FileLoader;